/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api documentation
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateProjectReq,
  ListProjectWsEventsParams,
  PinBody,
  ProjectDetailResp,
  ProjectListItemResp,
  ProjectListParams,
  ProjectWsEventsResp,
  TransferProjectOwnerReq,
  UpdateProjectReq,
} from "./project-api.schemas.js";

import { apiRequest } from "../context/api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const projectCreate = (
  createProjectReq?: CreateProjectReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ProjectDetailResp>(
    {
      url: `/intl/projects`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createProjectReq,
      signal,
    },
    options,
  );
};

export const getProjectCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof projectCreate>>,
    TError,
    { data?: CreateProjectReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof projectCreate>>,
  TError,
  { data?: CreateProjectReq },
  TContext
> => {
  const mutationKey = ["projectCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof projectCreate>>,
    { data?: CreateProjectReq }
  > = (props) => {
    const { data } = props ?? {};

    return projectCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProjectCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof projectCreate>>
>;
export type ProjectCreateMutationBody = CreateProjectReq | undefined;
export type ProjectCreateMutationError = unknown;

export const useProjectCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof projectCreate>>,
      TError,
      { data?: CreateProjectReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof projectCreate>>,
  TError,
  { data?: CreateProjectReq },
  TContext
> => {
  return useMutation(getProjectCreateMutationOptions(options), queryClient);
};
export const projectList = (
  params?: ProjectListParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ProjectListItemResp[]>(
    { url: `/intl/projects`, method: "GET", params, signal },
    options,
  );
};

export const getProjectListQueryKey = (params?: ProjectListParams) => {
  return [`/intl/projects`, ...(params ? [params] : [])] as const;
};

export const getProjectListQueryOptions = <
  TData = Awaited<ReturnType<typeof projectList>>,
  TError = unknown,
>(
  params?: ProjectListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof projectList>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProjectListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof projectList>>> = ({
    signal,
  }) => projectList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof projectList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ProjectListQueryResult = NonNullable<
  Awaited<ReturnType<typeof projectList>>
>;
export type ProjectListQueryError = unknown;

export function useProjectList<
  TData = Awaited<ReturnType<typeof projectList>>,
  TError = unknown,
>(
  params: undefined | ProjectListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof projectList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectList>>,
          TError,
          Awaited<ReturnType<typeof projectList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useProjectList<
  TData = Awaited<ReturnType<typeof projectList>>,
  TError = unknown,
>(
  params?: ProjectListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof projectList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectList>>,
          TError,
          Awaited<ReturnType<typeof projectList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useProjectList<
  TData = Awaited<ReturnType<typeof projectList>>,
  TError = unknown,
>(
  params?: ProjectListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof projectList>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useProjectList<
  TData = Awaited<ReturnType<typeof projectList>>,
  TError = unknown,
>(
  params?: ProjectListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof projectList>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getProjectListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const GetProjectDetail = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ProjectDetailResp>(
    { url: `/intl/projects/${id}`, method: "GET", signal },
    options,
  );
};

export const getGetProjectDetailQueryKey = (id: string) => {
  return [`/intl/projects/${id}`] as const;
};

export const getGetProjectDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof GetProjectDetail>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetProjectDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof GetProjectDetail>>
  > = ({ signal }) => GetProjectDetail(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof GetProjectDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof GetProjectDetail>>
>;
export type GetProjectDetailQueryError = unknown;

export function useGetProjectDetail<
  TData = Awaited<ReturnType<typeof GetProjectDetail>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetProjectDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetProjectDetail>>,
          TError,
          Awaited<ReturnType<typeof GetProjectDetail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectDetail<
  TData = Awaited<ReturnType<typeof GetProjectDetail>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetProjectDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetProjectDetail>>,
          TError,
          Awaited<ReturnType<typeof GetProjectDetail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectDetail<
  TData = Awaited<ReturnType<typeof GetProjectDetail>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetProjectDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetProjectDetail<
  TData = Awaited<ReturnType<typeof GetProjectDetail>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetProjectDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectDetailQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const projectUpdate = (
  id: string,
  updateProjectReq?: UpdateProjectReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ProjectDetailResp>(
    {
      url: `/intl/projects/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateProjectReq,
      signal,
    },
    options,
  );
};

export const getProjectUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof projectUpdate>>,
    TError,
    { id: string; data?: UpdateProjectReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof projectUpdate>>,
  TError,
  { id: string; data?: UpdateProjectReq },
  TContext
> => {
  const mutationKey = ["projectUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof projectUpdate>>,
    { id: string; data?: UpdateProjectReq }
  > = (props) => {
    const { id, data } = props ?? {};

    return projectUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProjectUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof projectUpdate>>
>;
export type ProjectUpdateMutationBody = UpdateProjectReq | undefined;
export type ProjectUpdateMutationError = unknown;

export const useProjectUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof projectUpdate>>,
      TError,
      { id: string; data?: UpdateProjectReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof projectUpdate>>,
  TError,
  { id: string; data?: UpdateProjectReq },
  TContext
> => {
  return useMutation(getProjectUpdateMutationOptions(options), queryClient);
};
export const projectDelete = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/intl/projects/${id}`, method: "DELETE", signal },
    options,
  );
};

export const getProjectDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof projectDelete>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof projectDelete>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["projectDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof projectDelete>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return projectDelete(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProjectDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof projectDelete>>
>;

export type ProjectDeleteMutationError = unknown;

export const useProjectDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof projectDelete>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof projectDelete>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getProjectDeleteMutationOptions(options), queryClient);
};
export const TransferOwner = (
  id: string,
  transferProjectOwnerReq?: TransferProjectOwnerReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ProjectDetailResp>(
    {
      url: `/intl/projects/${id}/transfer-owner`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: transferProjectOwnerReq,
      signal,
    },
    options,
  );
};

export const getTransferOwnerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof TransferOwner>>,
    TError,
    { id: string; data?: TransferProjectOwnerReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof TransferOwner>>,
  TError,
  { id: string; data?: TransferProjectOwnerReq },
  TContext
> => {
  const mutationKey = ["transferOwner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof TransferOwner>>,
    { id: string; data?: TransferProjectOwnerReq }
  > = (props) => {
    const { id, data } = props ?? {};

    return TransferOwner(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferOwnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof TransferOwner>>
>;
export type TransferOwnerMutationBody = TransferProjectOwnerReq | undefined;
export type TransferOwnerMutationError = unknown;

export const useTransferOwner = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof TransferOwner>>,
      TError,
      { id: string; data?: TransferProjectOwnerReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof TransferOwner>>,
  TError,
  { id: string; data?: TransferProjectOwnerReq },
  TContext
> => {
  return useMutation(getTransferOwnerMutationOptions(options), queryClient);
};
export const Archive = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ProjectDetailResp>(
    { url: `/intl/projects/${id}/archive`, method: "POST", signal },
    options,
  );
};

export const getArchiveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Archive>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Archive>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["archive"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Archive>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return Archive(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof Archive>>
>;

export type ArchiveMutationError = unknown;

export const useArchive = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Archive>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Archive>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getArchiveMutationOptions(options), queryClient);
};
export const Pin = (
  id: string,
  pinBody?: PinBody,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ProjectListItemResp>(
    {
      url: `/intl/projects/${id}/pin`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: pinBody,
      signal,
    },
    options,
  );
};

export const getPinMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Pin>>,
    TError,
    { id: string; data?: PinBody },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Pin>>,
  TError,
  { id: string; data?: PinBody },
  TContext
> => {
  const mutationKey = ["pin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Pin>>,
    { id: string; data?: PinBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return Pin(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PinMutationResult = NonNullable<Awaited<ReturnType<typeof Pin>>>;
export type PinMutationBody = PinBody | undefined;
export type PinMutationError = unknown;

export const usePin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Pin>>,
      TError,
      { id: string; data?: PinBody },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Pin>>,
  TError,
  { id: string; data?: PinBody },
  TContext
> => {
  return useMutation(getPinMutationOptions(options), queryClient);
};
export const ListProjectWsEvents = (
  id: string,
  params?: ListProjectWsEventsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ProjectWsEventsResp>(
    { url: `/intl/projects/${id}/events`, method: "GET", params, signal },
    options,
  );
};

export const getListProjectWsEventsQueryKey = (
  id: string,
  params?: ListProjectWsEventsParams,
) => {
  return [`/intl/projects/${id}/events`, ...(params ? [params] : [])] as const;
};

export const getListProjectWsEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof ListProjectWsEvents>>,
  TError = unknown,
>(
  id: string,
  params?: ListProjectWsEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListProjectWsEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListProjectWsEventsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof ListProjectWsEvents>>
  > = ({ signal }) => ListProjectWsEvents(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof ListProjectWsEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListProjectWsEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof ListProjectWsEvents>>
>;
export type ListProjectWsEventsQueryError = unknown;

export function useListProjectWsEvents<
  TData = Awaited<ReturnType<typeof ListProjectWsEvents>>,
  TError = unknown,
>(
  id: string,
  params: undefined | ListProjectWsEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListProjectWsEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListProjectWsEvents>>,
          TError,
          Awaited<ReturnType<typeof ListProjectWsEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProjectWsEvents<
  TData = Awaited<ReturnType<typeof ListProjectWsEvents>>,
  TError = unknown,
>(
  id: string,
  params?: ListProjectWsEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListProjectWsEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListProjectWsEvents>>,
          TError,
          Awaited<ReturnType<typeof ListProjectWsEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProjectWsEvents<
  TData = Awaited<ReturnType<typeof ListProjectWsEvents>>,
  TError = unknown,
>(
  id: string,
  params?: ListProjectWsEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListProjectWsEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListProjectWsEvents<
  TData = Awaited<ReturnType<typeof ListProjectWsEvents>>,
  TError = unknown,
>(
  id: string,
  params?: ListProjectWsEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListProjectWsEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListProjectWsEventsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
